<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Record payment</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="page-pad">

    <div class="field">
      <label class="field-label">Payment date</label>
      <div class="date-trigger filter-input" id="record-payment-date-trigger">
        <span>{{ paymentDate | date : 'dd MMM yyyy' }}</span>
        <ion-icon name="calendar-outline"></ion-icon>
      </div>
      <ion-popover trigger="record-payment-date-trigger" [keepContentsMounted]="true" side="bottom" alignment="start">
        <ng-template>
          <ion-datetime
            presentation="date"
            [value]="paymentDate"
            [max]="todayIso"
            [showDefaultButtons]="true"
            (ionChange)="onPaymentDate($event)">
          </ion-datetime>
        </ng-template>
      </ion-popover>
    </div>

    <app-payment-method-selector
      [(value)]="paymentMethod"
      [exclude]="excludeMethods">
    </app-payment-method-selector>

    <div class="field">
      <label class="field-label">Reference ID</label>
      <input
        class="filter-input"
        type="text"
        placeholder="Txn / UTR / cheque no."
        [(ngModel)]="referenceId" />
    </div>

    <div class="actions">
      <super-button
        type="fill"
        background="dark"
        color="light"
        errorInterface="toast"
        [disabled]="saving"
        [action]="submit">
        {{ saving ? 'Saving…' : 'Record payment' }}
      </super-button>
    </div>

  </div>
</ion-content>
